import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-list1",
  "use": "icon-list1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-list1\"><defs><style type=\"text/css\"></style></defs><path d=\"M800 544l-576 0C204.8 544 192 531.2 192 512l0 0c0-19.2 12.8-32 32-32l576 0C819.2 480 832 492.8 832 512l0 0C832 531.2 819.2 544 800 544z\" p-id=\"852\" /><path d=\"M800 352l-576 0C204.8 352 192 339.2 192 320l0 0c0-19.2 12.8-32 32-32l576 0C819.2 288 832 300.8 832 320l0 0C832 339.2 819.2 352 800 352z\" p-id=\"853\" /><path d=\"M800 736l-576 0C204.8 736 192 723.2 192 704l0 0c0-19.2 12.8-32 32-32l576 0c19.2 0 32 12.8 32 32l0 0C832 723.2 819.2 736 800 736z\" p-id=\"854\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/list1.svg
// module id = sCml
// module chunks = 183